import React from 'react';
import './App.css';
import { FinancialSetup, Header} from './';
import { ThemeProvider } from '@material-ui/styles';
import { createMuiTheme } from '@material-ui/core/styles';
import styled from 'styled-components';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#e45306'
    },
    secondary: {
      main: '#cd4a05'
    }
  }
});

const ContentTitle = styled.span`
  justify-self: center;
  font-size: 24px;
  align-self: end;
`;

const ContentTitleDiv = styled.div`
  display: grid;
  height: 100px;
  @media (max-width: 800px) {
    display: none;
  };
`;

function App() {
  if (!!window.Intercom) { 
    window.Intercom("boot", {
    app_id: "wifo69cn"
    }) 
  }
  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <Header/>
        <ContentTitleDiv>
          <ContentTitle>Calculadora de preço ideal</ContentTitle>
        </ContentTitleDiv>
        <FinancialSetup/>
      </div>
    </ThemeProvider>
  );
}

export default App;
